export type Scalars = {
  DateTime: string;
};

export type DocumentRequest = {
  id: string;
  creatorId: string;
  title: string;
  isFollowupEnabled: boolean;
};

export type DocumentRequestFile = {
  id: string;
  documentRequestId: string;
  fileName: string;
  fileDescription: string;
  isRequired: boolean;
  order: number;
};

export enum DocumentRequestStatus {
  SUCCEEDED = 'succeeded',
  IN_PROGRESS = 'in-progress',
  FAILED = 'failed',
}

export enum DocumentRequestFileStatus {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  ACTION_REQUIRED = 'action-required',
}

export type DocumentRequestUser = {
  id: string;
  documentRequestId: string;
  personId: string;
  creatorId: string;
  status: DocumentRequestStatus;
  actionRequiredFiles: number;
  hasPermission: boolean;
  isCollaborator: boolean;
  uploadedRequiredFiles: number;
  totalRequiredFiles: number;
  uploadedFiles: number;
  totalFiles: number;
};

export type DocumentRequestUserPermissions = {
  id: string;
  documentRequestId: string;
  personId: string;
};

export type DocumentRequestUserFile = {
  id: string;
  documentRequestUserId: string;
  documentId: string | null;
  personId: string;
  isRequired: boolean;
  status: DocumentRequestFileStatus;
  rejectionMessage: string | null;
  creatorId: string;
  hasPermission: boolean;
};

export enum DocumentStatus {
  UPLOADED = 'uploaded',
  IN_PROGRESS = 'in-progress',
  FAILED = 'failed',
}

export type Document = {
  createdAt: Scalars['DateTime'];
  creatorId: string | null;
  fileName: string;
  fileSize: number;
  hasContentPermission: boolean;
  id: string;
  isCollaborator: boolean;
  mimeType: string;
  personId: string;
  status: DocumentStatus;
};
